import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Product.Export.IRequest;
type Headers = Api.Core.Product.Export.IHeaders;
type ResponseString = Api.Core.Product.Export.IResponseString;
type ResponseFile = Api.Core.Product.Export.IResponseFile;
const baseUrl = '/api/ProductManagement/Product';
export async function productPricingExportExcelAsBase64Api(query?: Request): Promise<Api.Res<ResponseString>> {
  const serverResponse = await executeServerApi<Request, ResponseString, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(`${baseUrl}/ExportExcelAsBase64`, null, query),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function productPricingExportExcelAsFileApi(query?: Request): Promise<Api.Res<ResponseFile>> {
  const serverResponse = await executeServerApi<Request, ResponseFile, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(`${baseUrl}/ExportExcelAsFile`, null, query),
    headers: getDefaultHeaders(),
    keepRawResponse: true,
  });
  return serverResponse;
}
